// PageEstimate Component
/* eslint indent: 0 */

import React from 'react'
import HTML5Backend from 'react-dnd-html5-backend'
import { DragDropContext as dragDropContext } from 'react-dnd'
import async from 'async'
import _ from 'lodash'

import app from '../../../app.jsx'
import BudgetUtil from '../../../lib/budgetutil.jsx'
import eventfilters from '../../../lib/eventfilters.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import PageBase from '../../../common/page/page_base/page_base.jsx'
import EstimateContent from '../../estimate/estimate_content/estimate_content.jsx'
import EstimateAddItem from '../../estimate/estimate_additem/estimate_additem.jsx'
import DialogMail from '../../../common/dialog/dialog_email/dialog_email.jsx'
import DialogEstimateEdit from '../../dialog/dialog_estimate_edit/dialog_estimate_edit.jsx'
import DialogApproveEstimate from '../../dialog/dialog_estimate_approve/dialog_estimate_approve.jsx'
import DialogInvoiceAddress from '../../../invoice/dialog/dialog_invoice_address/dialog_invoice_address.jsx'
import DialogEstimateComplete from '../../dialog/dialog_estimate_complete/dialog_estimate_complete.jsx'
import DialogEstimateFinalize from '../../dialog/dialog_estimate_finalize/dialog_estimate_finalize.jsx'
import DNDUtil from '../../../lib/dndutil.jsx'
import Util from '../../../lib/util.jsx'
import currency from '../../../lib/currency.jsx'
import calculate from '../../../lib/calculate.jsx'
import ProfilerUtil from '../../../lib/profilerutil.jsx'
import InvoiceUtil from '../../../lib/invoiceutil.js'
import EmailUtil from '../../../lib/emailutil.js'
import DialogInvoiceAdd from '../../../invoice/dialog/dialog_invoice_add/dialog_invoice_add.jsx'
import PageHeader from '../../../theme/layout/page_header/page_header.jsx'
import TermsAndConditionText from '../../../common/form/terms_and_conditions/terms_and_conditions.jsx'
import { EXPENSE_RATE_CARD, PHASE_TYPES } from '../../../../shared/constants.js'
import { getTermsAndConditions } from '../../../lib/pdfTemplateUtils'
import DialogPdfPreview from '../../../common/dialog/dialog_pdf_preview/dialog_pdf_preview.jsx'
import { getEstimatePdfUrl, isEmptyEstimateItem } from './utils'
import { EstimatesIcon } from '../../../common/layout/menu_icons/estimates.jsx'

@dragDropContext(HTML5Backend)
class PageEstimateView extends PageBase {
  constructor (props) {
    super(props, 'estimate-view', 'estimate', 'estimate-view')

    this.state = {
      profilerId: null,
      loading: {
        isCreatingInvoice: false,
        isReopening: false,
        isSendingEmail: false
      }
    }

    this.data = {
      budget: null,
      items: [],
      projectBudget: null,
      budgetItems: [],
      phaseList: [],
      activityList: [],
      estimateRateCards: [],
      emailSuggestions: [],
      taxRateVatOptions: [],
      quickbookItems: [],
      showTermsAndCondition: true,
      termsCleared: false
    }

    this.showApprove = true
    this._setFABButtonState(true, true)
    this._initRealTimeVariables()
    this._references = {
      refDialogEstimateFinalize: React.createRef(),
      refDialogEstimateComplete: React.createRef(),
      refDialogEstimateEdit: React.createRef(),
      refdialogMail: React.createRef(),
      refDialogInvoiceAddress: React.createRef(),
      dialogInvoiceAdd: React.createRef(),
      refDialogApproveEstimate: React.createRef(),
      estimateItemAdd: React.createRef(),
      estimateContent: React.createRef(),
      dialogPdfPreview: React.createRef()
    }

    this.pdfDownloadUrl = ''

    /* Initialize profiler */
    this._profiler = new ProfilerUtil(this._pageIdent, 3) // Average time 3 seconds
    this._profiler.start()
    this._profiler.setParams(props.estimateId)

    this._bUnMounted = false
  }

  componentDidMount () {
    this._getData(false, true)
    this._initEvents()

    // Init DND scroll events
    DNDUtil.initEvents()

    // Calculate and save profiler, Hardcode profiler id as 1, since it is the first call of profiler
    this._profiler.stop(1)
  }

  componentWillUnmount () {
    this._bUnMounted = true

    this._releaseEvents()

    // Release DND scroll events
    DNDUtil.releaseEvents()

    this._profiler = null
  }

  componentDidUpdate (prevProps, prevState) {
    if (
      this._profiler &&
      (!prevState || prevState.profilerId !== this.state.profilerId) &&
      this.state.profilerId
    ) {
      this._profiler.stop(this.state.profilerId)
    }
  }

  toggleLoading (key, isLoading) {
    this.setState(prevState => ({ ...prevState, loading: { ...prevState.loading, [key]: isLoading } }))
  }

  renderContent () {
    let bDisable = false
    const estimate = this.data.estimate
    if (
      estimate &&
      (estimate.status === 'Approved' || estimate.status === 'Declined')
    ) {
      bDisable = true
    }

    const _className = `pageinnercont ${bDisable ? 'disabled' : ''}`
    const profile =
      app.getTeam() && app.getTeam().profile ? app.getTeam().profile : null

    const { pdfDownloadUrl } = this

    return (
      <div className={_className}>
        {this.data.budget && (
          <EstimateContent
            ref={this._references.estimateContent}
            budget={BudgetUtil.getRenderObject(
              this.data.budget,
              this.data.items
            )}
            estimateRateCards={this.data.estimateRateCards}
            projectBudget={this.data.projectBudget}
            phaseList={this.data.phaseList}
            activityList={this.data.activityList}
            introText={this.data.estimate.introText}
            hasPageBreakTop={this.data.estimate.hasPageBreakTop}
            isQuickbookConnected={app.isQuickbookConnected()}
            quickbookItems={this.data.quickbookItems}
            onChange={this._onChangeBudget.bind(this)}
            onItemCreate={this._onItemCreate.bind(this)}
            onItemUpdate={this._onItemUpdate.bind(this)}
            onItemRemove={this._onItemRemove.bind(this)}
            processPhaseSelect={this._processPhaseSelect.bind(this)}
            onSearchSupplier={BudgetUtil.onSearchSupplier.bind(this)}
            createNewActivity={this._onCreateNewActivity.bind(this)}
            onUpdateIntroText={this._onUpdateIntroText.bind(this)}
            onUpdateInfo={this._onUpdateEstimateInfo.bind(this)}
            onPhaseRemove={this._onPhaseRemove.bind(this)}
            onCopyPhase={this._onCopyPhase.bind(this)}
            calculateSpentAmount={this._calculateSpentAmount.bind(this)}
            projectTitle={
              this.data.estimate && this.data.estimate.project
                ? this.data.estimate.project.title
                : ''
            }
            contactName={
              this.data.estimate && this.data.estimate.contact
                ? this.data.estimate.contact.company
                : ''
            }
            estimate={this.data.estimate}
            teamCountry={profile ? profile.country : ''}
            vatRate={
              profile && profile.vatRate ? parseFloat(profile.vatRate) : 0
            }
            taxRateVatOptions={this.data.taxRateVatOptions}
            onUpdateEstimateTotal={this._onUpdateEstimateTotal.bind(this)}
            onUpdateEstimateType={this._onUpdateEstimateType.bind(this)}
            onCreateTaxRate={this._onCreateTaxRate.bind(this)}
            reloadQuickbookItems={this._reloadQuickbookItems.bind(this)}
          />
        )}
        {this._renderTermsAndCondition()}
        {this._renderAddItem()}
        <DialogMail
          ref={this._references.refdialogMail}
          onSubmit={this._onSubmitMail.bind(this)}
          isLoading={this.state.loading.isSendingEmail}
          downloadUrl={pdfDownloadUrl}
          showWithoutContext
          mailSuggestions={this.data.emailSuggestions}
          showMultiAttachments
          showLanguage={app.teamCountry === 'NL' || app.teamCountry === 'DE'}
        />
        <DialogEstimateEdit
          ref={this._references.refDialogEstimateEdit}
          supplierSearch={this._onSearchContact.bind(this)}
          getProjects={this._getProjects.bind(this)}
          onSubmit={this._onSubmitEstimateEdit.bind(this)}
          onDelete={this._onDeleteEstimate.bind(this)}
          projectId={
            this.data.estimate && this.data.estimate.projectId
              ? this.data.estimate.projectId
              : ''
          }
          showLanguage={app.teamCountry !== 'US'}
        />
        <DialogPdfPreview
          title={
            IntlUtil.convertMessage('estimate.view.pdfPreviewDialogTitle')
          }
          ref={this._references.dialogPdfPreview}
          onClickNext={this.handleMarkAsOpen}
        />
        <DialogApproveEstimate
          ref={this._references.refDialogApproveEstimate}
          onSubmit={this._onSubmitEstimateApprove.bind(this)}
        />
        <DialogEstimateFinalize
          ref={this._references.refDialogEstimateFinalize}
          onSubmit={this._onSubmitFinalize.bind(this)}
          onClickGoBack={this.handleGoBackToPdfPreview}
        />
        <DialogInvoiceAddress
          ref={this._references.refDialogInvoiceAddress}
          message='estimate.form.contactInfo'
          teamCountry={app.teamCountry}
          onSubmit={this._onSubmitAddressInvoice.bind(this)}
        />
        <DialogEstimateComplete
          ref={this._references.refDialogEstimateComplete}
          downloadUrl={pdfDownloadUrl}
          onMail={this._onMailApproveEstimate.bind(this)}
        />
        <DialogInvoiceAdd
          ref={this._references.dialogInvoiceAdd}
          invoiceIntroText={this.data.estimate && this.data.estimate.introText}
          getProjects={InvoiceUtil.getProjects}
          contactSearch={this._onSearchContact.bind(this)}
          onSubmit={this._onAddInvoice.bind(this)}
          getInvoiceInfo={InvoiceUtil.generateInvoice}
        />
      </div>
    )
  }

  _calculateSpentAmount (item, callback) {
    callback()
  }

  _onSubmitFinalize (estObj) {
    app
      .service('/api/estimate')
      .patch(this.data.estimate.id, estObj)
      .then((estRes) => {
        if (this._references.refDialogEstimateFinalize.current) {
          this._references.refDialogEstimateFinalize.current.hide()
        }
        if (this._references.refDialogEstimateComplete.current) {
          this._references.refDialogEstimateComplete.current.show(
            estRes.estimateNumber
          )
        }
      })
      .catch((decErr) => {
        app.debug('PageEstimateView _onSubmitFinalize err', decErr)
      })
  }

  _reloadQuickbookItems () {
    return app
      .service('/api/quickbook/syncitem')
      .create({})
      .then((itemRes) => {
        this.data.quickbookItems = itemRes.data || []
        this.setState({ dataDate: new Date() })
      })
      .catch((err) => {
        app.debug('PageprojectViewBudget: _reloadQuickbookItems Error', err)
      })
  }

  getContentClassname () {
    return 'alt full'
  }

  /* Event handlers */
  _onEdit (event) {
    event.preventDefault()
    const estimate = this.data.estimate
    const contact = estimate.contact
    const contactAddresses =
      estimate && contact && contact.addresses ? contact.addresses : null
    const params = {}
    if (estimate) {
      app
        .service('/api/contact')
        .get(estimate.contactId, params)
        .then((result) => {
          if (result) {
            const contactoptions = { label: result.company, value: result.id }
            const estObj = {
              contactId: estimate.contactId,
              projectId: estimate.projectId,
              options: contactoptions,
              addressOptions: this._getContactAddressOptions(estimate),
              addresses: contactAddresses,
              contactPersonOptions: this._getContactPersonOptions(contact),
              contactPerson: estimate.contactPerson
                ? `${estimate.contactPerson.name}${
                    estimate.contactPerson.email
                      ? ' - ' + estimate.contactPerson.email
                      : ''
                  }`
                : '',
              contactAddress:
                estimate.contactAddress && estimate.contactAddress.type
                  ? estimate.contactAddress
                  : contactAddresses
                  ? contactAddresses[0]
                  : null,
              pdfLanguage: calculate.getFileLanguage(
                estimate,
                estimate.contact,
                app.getTeam()
              )
            }

            if (this._references.refDialogEstimateEdit.current) {
              this._references.refDialogEstimateEdit.current.show(estObj)
            }
          }
        })
        .catch((err) => {
          app.debug('PageEstimateView: _onEdit err', err)
        })
    }
  }

  _onCopyPhase (budget, budgetData, phase, callback) {
    const copyPhaseData = {
      estimateId: this.props.estimateId,
      budget: BudgetUtil.getSaveObject(budgetData, true).budget,
      items: []
    }

    const newPhase = _.cloneDeep(phase)
    newPhase.id = budget.phases.length
    newPhase.status = 'estimate'
    newPhase.spentAmount = 0
    newPhase.title = `${IntlUtil.convertMessage(
      'common.list.copyNewPhasePrefix'
    )} ${newPhase.title || ''}`

    if (newPhase.groups && newPhase.groups.length > 0) {
      newPhase.groups.map((group) => {
        if (group.items && group.items.length > 0) {
          group.items.map((item, itemIdx) => {
            const newItem = BudgetUtil.getNewItemObject(item, true)
            delete newItem.id
            newItem.phaseNo = newPhase.id + 1
            newItem.orderNo = itemIdx + 1
            newItem.spentAmount = 0
            newItem.percentage = 0
            if (!isEmptyEstimateItem(newItem)) {
              copyPhaseData.items.push({ data: newItem })
            }
          })
        }
      })
    }

    app
      .service('/api/estimate/copyphase')
      .create(copyPhaseData)
      .then((copyRes) => {
        if (copyRes) {
          callback(
            BudgetUtil.getRenderPhaseObject(
              budget,
              newPhase,
              budget.phases.length,
              copyRes.items
            )
          )
        }
      })
      .catch((createItemErr) => {
        app.debug('PageProjectViewBudget: _onCopyPhase err', createItemErr)
      })
  }

  _getContactPersonOptions (contact) {
    const contactPersonOptions = []
    if (
      contact &&
      contact.contactPersons &&
      contact.contactPersons.length > 0
    ) {
      contact.contactPersons.map((contactPerson) => {
        const label =
          contactPerson.name +
          (contactPerson.email ? ' - ' + contactPerson.email : '')
        contactPersonOptions.push({
          label: label,
          value: label,
          obj: contactPerson
        })
      })
    }

    return contactPersonOptions
  }

  _getContactAddressOptions (estimate) {
    const addressOptions = []
    const contact = estimate.contact
    if (contact && contact.addresses && contact.addresses.length > 0) {
      contact.addresses.map((address) => {
        const existTypeOption = _.find(
          addressOptions,
          (addressOption) => addressOption.label === address.type
        )
        const label = IntlUtil.convertMessage(
          `contact.view.type${address.type}`
        )
        if (existTypeOption === undefined) {
          addressOptions.push({
            label: label,
            value: address.type.toLowerCase()
          })
        }
      })
    }

    if (
      estimate.contactAddress &&
      addressOptions.length > 1 &&
      addressOptions[0].value === undefined
    ) {
      const label = IntlUtil.convertMessage(
        `contact.view.type${estimate.contactAddress.type}`
      )
      addressOptions.push({
        label: label,
        value: estimate.contactAddress.type.toLowerCase()
      })
    }

    return addressOptions
  }

  _onSendMail (event) {
    if (event) {
      event.preventDefault()
    }

    app.debug('### PageEstimateView - _onSendMail')
    const params = { query: {} }
    app
      .service('/api/estimate/mail')
      .get(this.props.estimateId, params)
      .then((result) => {
        if (result && this._references.refdialogMail.current) {
          this._references.refdialogMail.current.show(result)
        }
      })
      .catch((err) => {
        app.debug('PageEstimateView: _onSendMail err', err)
      })
  }

  _onDownload (event) {
    event.preventDefault()
    this._downloadEstimate()
  }

  _getContactPersonOrDefault (estimate, contactPersons) {
    let contactPersonIdent = ''
    if (estimate.contactPerson) {
      contactPersonIdent = `${estimate.contactPerson.name}${
        estimate.contactPerson.email ? ' - ' + estimate.contactPerson.email : ''
      }`
    } else if (contactPersons.length > 0) {
      contactPersonIdent = contactPersons[0].value
    }

    return contactPersonIdent
  }

  _onFinalize () {
    const estimate = this.data.estimate
    const contactPersonOptions = this._getContactPersonOptions(
      estimate.contact
    )

    if (estimate) {
      const estFinalObj = {
        total: estimate && estimate.budget ? estimate.budget.total : '',
        contactName: estimate.contact.company,
        addressOptions: this._getContactAddressOptions(estimate),
        addresses:
          estimate && estimate.contact && estimate.contact.addresses
            ? estimate.contact.addresses
            : null,
        contactPersonOptions: contactPersonOptions,
        contactPerson: this._getContactPersonOrDefault(
          estimate,
          contactPersonOptions
        ),
        contactAddress: estimate.contactAddress ? estimate.contactAddress : ''
      }
      if (this._references.refDialogEstimateFinalize.current) {
        this._references.refDialogEstimateFinalize.current.show(estFinalObj)
      }
    }
  }

  _downloadEstimate = async () => {
    const teamId = app.getTeamId()
    if (this.data.estimate) {
      const createObj = {
        estimateId: this.data.estimate.id
      }
      try {
        const pdfRes = await app
          .service('/api/estimate/pdf')
          .create(createObj, {})
        app.redirect(
          encodeURI(`/estimate/download/${teamId}/${pdfRes.pdfName}`)
        )
      } catch (pdfErr) {
        app.debug('PageEstimateView: _onDownload', pdfErr)
      }
    }
  };

  _onApprove = () => {
    const estimate = this.data.estimate
    const contactPersonOptions = this._getContactPersonOptions(
      estimate.contact
    )

    if (estimate) {
      const estimateObj = {
        estimateNumber: estimate.estimateNumber,
        reviewedOn: estimate.reviewedOn,
        addressOptions: this._getContactAddressOptions(estimate),
        addresses:
          estimate && estimate.contact && estimate.contact.addresses
            ? estimate.contact.addresses
            : null,
        contactPersonOptions: contactPersonOptions,
        contactPerson: this._getContactPersonOrDefault(
          estimate,
          contactPersonOptions
        ),
        contactAddress: estimate.contactAddress ? estimate.contactAddress : '',
        total: estimate.budget.total
      }
      if (this._references.refDialogApproveEstimate.current) {
        this._references.refDialogApproveEstimate.current.show(estimateObj)
      }
    }
  };

  _onChangeStatus (status, event) {
    event.preventDefault()
    app.debug('### PageEstimateView - _onDecline')
    this.toggleLoading('isReopening', true)

    const estimate = this.data.estimate
    app
      .service('/api/estimate')
      .patch(estimate.id, { status: status })
      .then((_estRes) => {
        this.showApprove = false
      })
      .catch((decErr) => {
        app.debug('PageEstimateView _onSubmitFinalize err', decErr)
      })
      .finally(() => {
        this.toggleLoading('isReopening', false)
      })
  }

  _onClickMarkAsOpen = () => {
    this._references.dialogPdfPreview.current.show(this.pdfDownloadUrl)
  };

  handleGoBackToPdfPreview = () => {
    this._references.refDialogEstimateFinalize.current.hide()
    this._references.dialogPdfPreview.current.show(this.pdfDownloadUrl)
  };

  handleMarkAsOpen = () => {
    this._references.dialogPdfPreview.current.hide()

    const estimate = this.data.estimate
    const contactPersonOptions = this._getContactPersonOptions(
      estimate.contact
    )

    if (
      estimate.contactAddress === undefined ||
      (estimate.contactAddress !== undefined &&
        (!estimate.contactAddress.street ||
          !estimate.contactAddress.city ||
          !estimate.contactAddress.postcode))
    ) {
      const contObj = {
        contactName: estimate.contact.company,
        address: estimate.contactAddress,
        vatNo: estimate.contact.vatNo,
        contactPersonOptions: contactPersonOptions,
        contactPerson: this._getContactPersonOrDefault(
          estimate,
          contactPersonOptions
        )
      }
      if (this._references.refDialogInvoiceAddress.current) {
        this._references.refDialogInvoiceAddress.current.show(contObj, true)
      }
    } else {
      this._onFinalize()
    }
  };

  _onReopen (event) {
    event.preventDefault()
    app.debug('### PageEstimateView - _onReopen')
  }

  _onCreateInvoice (ev) {
    ev.preventDefault()
    this.toggleLoading('isCreatingInvoice', true)

    const estimate = this.data.estimate
    InvoiceUtil.getProjects(estimate.contactId, (projects) => {
      if (this._references.dialogInvoiceAdd.current) {
        this._references.dialogInvoiceAdd.current.showByEstimate({
          contactId: estimate.contactId,
          contactName: estimate.contact.company,
          projectId: estimate.projectId,
          estimateId: estimate.id,
          bApproved: estimate.status === 'Approved',
          projects: projects,
          referenceNo: estimate.referenceNumber
        }, () => {
          this.toggleLoading('isCreatingInvoice', false)
        })
      }
    })
  }

  _getData (bReload, bGetPageData, callback) {
    // Start profiler
    const profilerId = this._profiler ? this._profiler.start() : 0
    this._setDataLoading()

    const team = app.getTeam()
    const teamCountry = team && team.profile ? team.profile.country : ''

    const params = {
      query: {
        bUpdatePageState: bReload,
        bGetPageData: bGetPageData,
        pageState: this.data.pageState,
        pageIdent: this._pageIdent,
        estimateId: this.props.estimateId,
        bGetQuickbookItem: app.isQuickbookConnected(),
        bGetVatOptions: teamCountry === 'US',
        bGetPoDetails: !!(this.data.estimate && this.data.estimate.budget),
        estimate: {
          $client: {
            subObjects: {
              project: ['budget', 'title', 'projectNumber'],
              contact: [
                'company',
                'addresses',
                'vatNo',
                'rateCards',
                'contactPersons',
                'pdfLanguage'
              ],
              items: []
            }
          }
        },
        estimateItems: {
          estimateId: this.props.estimateId,
          $sort: { orderNo: 1 },
          $client: {
            getPurchaseOrderClients: true
          }
        }
      }
    }

    app
      .service('/api/page/estimate/view')
      .find(params)
      .then(async (result) => {
        if (result) {
          if (result.estimate) {
            const estimate = result.estimate
            this.data.estimate = estimate
            this.data.budget = this.data.estimate.budget
            this.data.estimate.vats = []
            if (!this.data.budget) {
              this.data.budget = BudgetUtil.createEmptyBudget()
            }

            if (!estimate.termsAndCondition && !this.data.termsCleared) {
              this.data.estimate.termsAndCondition = await getTermsAndConditions(
                app.getTeamId(),
                'estimate'
              )

              const updateObj = {
                termsAndCondition: this.data.estimate.termsAndCondition
              }

              this._onUpdateEstimateInfo(updateObj)
            }

            if (estimate.project.budget) {
              const budget = estimate.project.budget
              this.data.projectBudget = budget

              if (budget.phases && budget.phases.length > 0) {
                budget.phases.map((phase) => {
                  this.data.phaseList.push({
                    label: phase.title,
                    value: phase.title
                  })
                })
              }
            }

            if (this.data.estimate) {
              this.data.emailSuggestions = EmailUtil.getEmailSuggestions(
                this.data.estimate.contact
              )
            }

            this.data.estimateRateCards = []
            const rateCards =
              estimate.contact && estimate.contact.rateCards
                ? estimate.contact.rateCards
                : []
            if (rateCards && rateCards.length > 0) {
              rateCards.map((rateCard) => {
                const rateCardObj = {
                  label: this._formRateCardLabel(rateCard),
                  value: rateCard.name,
                  amount: rateCard.amount,
                  labelHasHtml: true
                }

                this.data.estimateRateCards.push(rateCardObj)
              })
            }

            this.pdfDownloadUrl = getEstimatePdfUrl(estimate)
          }

          if (result.estimateItems.length > 0) {
            this.data.items = result.estimateItems
          }

          if (result.taxRates.length > 0) {
            this.data.taxRateVatOptions = []

            const taxRate = result.taxRates[0]
            if (taxRate && taxRate.rates && taxRate.rates.length > 0) {
              taxRate.rates.forEach((rate) => {
                const vatOption = {
                  label: rate.title,
                  value: rate.percentage,
                  editable: false,
                  isService: rate.isService,
                  isProduct: rate.isProduct
                }

                this.data.taxRateVatOptions.push(vatOption)
              })
            }
          }

          if (result.budgetItems.length > 0) {
            this.data.budgetItems = result.budgetItems

            const vatInfo = calculate.calculateVatFromItems(this.data.items)
            this.data.estimate.vats = vatInfo.vats || []
          }
        }

        this.data.quickbookItems = result.quickbookItems || []

        if (bGetPageData) {
          this._onDataReceived(null, profilerId)
        }

        if (callback) {
          callback(null)
        }
      })
      .catch((err) => {
        if (bGetPageData) {
          this._onDataReceived(err, profilerId)
        }

        if (callback) {
          callback(err)
        }
      })
  }

  _formRateCardLabel (rateCard, cardType) {
    return `<span class="label">
        <span class="title">${rateCard.name}</span>
        <span class="type">
          ${cardType ? `${IntlUtil.convertMessage(cardType)} - ` : ''}
          ${rateCard.amount} p/u
          ${
            rateCard.type === EXPENSE_RATE_CARD
              ? ` - ${rateCard.markupPercentage} %`
              : ''
          }
        </span>
      </span>`
  }

  _onSubmitMail (mailObj) {
    this.toggleLoading('isSendingEmail', true)

    app.debug('PageEstimateView: _onSubmitMail [Start]')

    EmailUtil.sendEstimateMail(mailObj, this.data.estimate)
      .then((_result) => {
        if (this._references.refdialogMail.current) {
          this._references.refdialogMail.current.hide()
        }
        this.toggleLoading('isSendingEmail', false)
      })
      .catch((err) => {
        app.debug('PageEstimateView: _onSubmitMail err', err)
      })
  }

  _onDownloadMailInvoice (_estimateId) {
    this._downloadEstimate()
  }

  _onDataReceived (err, profilerId) {
    if (this._bUnMounted) return

    this._setDataLoaded()

    if (err) {
      app.debug('PageEstimateView: _onDataReceived Error', err)
      this._setFABButtonVisible(false)
      this.setState({
        loading: true,
        dataDate: new Date(),
        profilerId: profilerId
      })
    } else {
      app.debug('PageEstimateView: _onDataReceived [done]')
      if (
        this.data.estimate &&
        (this.data.estimate.status === 'Draft' ||
          this.data.estimate.status === 'Open')
      ) {
        this._setFABButtonVisible(true)
      } else {
        this._setFABButtonVisible(false)
      }

      this.setState({
        loading: !this.data.estimate,
        dataDate: new Date(),
        profilerId: profilerId
      })
      app.updatePageTitle(
        'estimate-view',
        this.data.estimate ? this.data.estimate.title : ''
      )
    }
  }

  _onSearchContact (keyword, callback) {
    this._onCommonFilterContactSearch(keyword, callback)
  }

  _getProjects (contactId, callback) {
    if (contactId) {
      const params = {
        query: {
          contactId: contactId
        }
      }

      app
        .service('/api/project')
        .find(params)
        .then((result) => {
          if (result) {
            const options = result.data.map((obj) => ({
              label: obj.title,
              value: obj.id
            }))
            callback(options)
          } else {
            callback([]) // eslint-disable-line standard/no-callback-literal
          }
        })
        .catch((err) => {
          app.debug('PageEstimateView: _getProjects err', err)
          callback([]) // eslint-disable-line standard/no-callback-literal
        })
    } else {
      callback([]) // eslint-disable-line standard/no-callback-literal
    }
  }

  _onSubmitEstimateEdit (estObj) {
    const estimate = this.data.estimate
    app
      .service('/api/estimate')
      .patch(estimate.id, estObj)
      .then((_estRes) => {
        if (this._references.refDialogEstimateEdit.current) {
          this._references.refDialogEstimateEdit.current.hide()
        }
      })
      .catch((estErr) => {
        app.debug('PageEstimateView: _onSubmitEstimateEdit err', estErr)
      })
  }

  _onDeleteEstimate () {
    if (!this.data.estimate.id) {
      return false
    }

    app
      .service('/api/estimate')
      .remove(this.data.estimate.id)
      .then((_deleteRes) => {
        if (this._references.refDialogEstimateEdit.current) {
          this._references.refDialogEstimateEdit.current.hide()
        }
        app.changePage('estimate')
      })
      .catch((deleteErr) => {
        app.debug('PageEstimateView delete err', deleteErr)
      })
  }

  _refresh () {
    this.setState({ dataDate: new Date() })
  }

  _onSubmitEstimateApprove (estObj, onFinish = () => {}) {
    const estimate = this.data.estimate
    app
      .service('/api/estimate')
      .patch(estimate.id, estObj)
      .then((_estRes) => {
        if (this._references.refDialogApproveEstimate.current) {
          this._references.refDialogApproveEstimate.current.hide()
        }
      })
      .catch((estErr) => {
        app.debug('PageEstimateView: _onSubmitEstimateApprove err', estErr)
      })
      .finally(() => {
        if (onFinish) onFinish()
      })
  }

  _onMailApproveEstimate (_bFullDetails) {
    if (this._references.refDialogApproveEstimate.current) {
      this._references.refDialogApproveEstimate.current.hide()
    }
    if (this._references.refDialogEstimateComplete.current) {
      this._references.refDialogEstimateComplete.current.hide()
    }
    this._showEmailDialog()
  }

  _showEmailDialog () {
    app.debug('### PageEstimateView - _showEmailDialog')
    const params = { query: {} }
    app
      .service('/api/estimate/mail')
      .get(this.props.estimateId, params)
      .then((result) => {
        if (result && this._references.refdialogMail.current) {
          this._references.refdialogMail.current.show(result)
        }
      })
      .catch((err) => {
        app.debug('PageEstimateView: _showEmailDialog err', err)
      })
  }

  _onAddInvoice (createObj, phaseId, onFinish) {
    const params = {
      query: {
        phaseId: phaseId,
        $client: {
          dateMethod: createObj.dateMethod
        }
      }
    }
    const invoiceObj = _.cloneDeep(createObj)
    delete invoiceObj.dateMethod
    delete invoiceObj.approveDate
    delete invoiceObj.approveEstimate

    InvoiceUtil.createInvoice(invoiceObj, params, (err, res) => {
      if (onFinish) onFinish()
      if (err) {
        app.debug('PageEstimateView: _onAddInvoice err', err)
      } else {
        if (this._references.dialogInvoiceAdd.current) {
          this._references.dialogInvoiceAdd.current.hide()
        }
        app.changePage('invoice-view', res.id)
      }
    })
  }

  // Called when item title completed
  _onItemCreate (item) {
    /* if (item.type === 'subtotal') {
      return false;
    } */

    const createObj = BudgetUtil.getNewItemObject(item, true)
    delete createObj.id

    createObj.estimateId = this.props.estimateId

    app
      .service('/api/estimate/item')
      .create(createObj)
      .then((createItemRes) => {
        if (createItemRes) {
          item.id = createItemRes.id
          item.estimateId = createItemRes.estimateId
        }
      })
      .catch((createItemErr) => {
        app.debug('PageEstimateView: _onItemCreate err', createItemErr)
      })
  }

  // Called when item title, date, description, po - all cases if total save is not called
  _onItemUpdate (item, attribute, callback) {
    if (!item.id) {
      /* || item.type === 'subtotal') { */
      return false
    }

    const updateObj = BudgetUtil.getUpdateItemObject(item, attribute)
    app
      .service('/api/estimate/item')
      .patch(item.id, updateObj)
      .then((_updItemRes) => {
        if (callback) {
          callback(null)
        }
      })
      .catch((updItemErr) => {
        app.debug('PageEstimateView: _onItemUpdate err', updItemErr)
        if (callback) {
          callback(updItemErr)
        }
      })
  }

  _onItemRemove (item, callback) {
    if (!item.id) {
      return false
    }

    app
      .service('/api/estimate/item')
      .remove(item.id)
      .then(_remItemRes => {
        if (callback) {
          callback()
        }
      })
      .catch(remItemErr => {
        app.debug('PageEstimateView: _onItemRemove err', remItemErr)
      })
  }

  _onCreateNewActivity (budget, type, phase, groupId) {
    const team = app.getTeam()
    let vat =
      team && team.profile && team.profile.vatRate
        ? parseFloat(team.profile.vatRate)
        : 0
    const teamCountry = team && team.profile ? team.profile.country : ''

    const address =
      this.data.estimate && this.data.estimate.contactAddress
        ? this.data.estimate.contactAddress
        : null

    if (teamCountry && address && address.country) {
      let estimateCountry = address.country
      if (estimateCountry === 'GB') {
        estimateCountry = 'UK'
      }

      if (!Util.isEuropeCountry(estimateCountry)) {
        vat = 0
      } else if (
        teamCountry !== estimateCountry &&
        Util.isEuropeCountry(estimateCountry)
      ) {
        vat = 0
      }
    }

    return BudgetUtil.createNewActivity(
      budget,
      type,
      phase,
      groupId,
      true,
      vat,
      null,
      0
    )
  }

  _onUpdateEstimateTotal (totalExcl, totalInc) {
    const updateObj = {
      totalExcl: totalExcl,
      totalInc: totalInc
    }

    app
      .service('/api/estimate')
      .patch(this.props.estimateId, updateObj)
      .then((_updateRes) => {
        /* Always Reload if total updated */
        this._isDataLoading = false
        this._lastReloadTime = null
      })
      .catch((updateErr) => {
        app.debug('PageEstimateView: _onUpdateEstimateTotal err', updateErr)
      })
  }

  _onChangeBudget (budgetObj) {
    const saveObj = BudgetUtil.getSaveObject(budgetObj, true)

    async.series(
      [
        (done) => {
          app
            .service('/api/estimate')
            .patch(this.props.estimateId, {
              budget: saveObj.budget,
              totalExcl: saveObj.budget.total
            })
            .then((_estimateRes) => {
              done(null)
            })
            .catch((estimateErr) => {
              done(estimateErr)
            })
        }
      ],
      (asynErr, _asyncRes) => {
        if (asynErr) {
          app.debug('PageEstimateView: _onChangeBudget err', asynErr)
        } else {
          this.setState({ dataDate: new Date() })
        }
      }
    )
  }

  _saveBudgetItems (estimateId, items, callback) {
    const estimateItemService = app.service('/api/estimate/item')

    async.map(
      items,
      (item, mapDone) => {
        const updateId = item.id

        const updateItem = _.cloneDeep(item)
        delete updateItem.id

        if (updateId) {
          estimateItemService
            .patch(updateId, updateItem)
            .then((_updItemRes) => {
              mapDone(null)
            })
            .catch((updItemErr) => {
              mapDone(updItemErr)
              app.debug('PageEstimateView: _saveBudgetItems err', updItemErr)
            })
        }
      },
      (asyncErr, _asyncRes) => {
        if (asyncErr) {
          callback(asyncErr)
        } else {
          callback(null)
        }
      }
    )
  }

  _processPhaseSelect (phaseTitle, callback) {
    let budgetItems = null
    const estimateItemService = app.service('/api/estimate/item')
    const projectBudget = BudgetUtil.getRenderObject(
      this.data.projectBudget,
      this.data.budgetItems
    )

    if (projectBudget && projectBudget.phases) {
      let selPhase = null
      let phaseIdx = null
      projectBudget.phases.map((phase, budgetPhaseIdx) => {
        if (phase.title === phaseTitle) {
          selPhase = phase
          phaseIdx = budgetPhaseIdx
        }
      })

      if (selPhase) {
        budgetItems = []
        selPhase.groups.map((group, _groupIdx) => {
          group.items.map((groupItem, _itemIdx) => {
            const item = _.cloneDeep(groupItem)
            item.editable = false
            item.bTitleCompleted = true
            item.phaseId = phaseIdx

            delete item.contactId
            delete item.projectId
            delete item.timeSpent
            delete item.schedules
            delete item.skills
            delete item.allcoatedHours

            budgetItems.push(item)
          })
        })
      }
    }

    const savedItems = []
    async.map(
      budgetItems,
      (budgetItem, mapDone) => {
        const createObj = _.cloneDeep(
          BudgetUtil.getNewItemObject(budgetItem, true)
        )
        delete createObj.id

        createObj.groupNo = budgetItem.groupNo
        createObj.orderNo = budgetItem.orderNo
        createObj.estimateId = this.props.estimateId

        estimateItemService
          .create(createObj)
          .then((createItemRes) => {
            if (createItemRes) {
              savedItems.push(createItemRes)
              mapDone(null)
            }
          })
          .catch((createItemErr) => {
            mapDone(createItemErr)
            app.debug(
              'PageEstimateView: _processPhaseSelect err',
              createItemErr
            )
          })
      },
      (err) => {
        if (err) {
          callback([]) // eslint-disable-line standard/no-callback-literal
        } else {
          callback(savedItems)
        }
      }
    )
  }

  onFABClose () {
    if (this._references.estimateItemAdd.current) {
      this._references.estimateItemAdd.current.hide()
    }
  }

  onAdd () {
    if (this._references.estimateItemAdd.current) {
      this._references.estimateItemAdd.current.show()
    }
  }

  _onIntroAdd (ev) {
    ev.preventDefault()

    if (this.data.estimate.introText === null) {
      this.data.estimate.introText = ''
    }
    if (this._references.estimateContent.current) {
      this._references.estimateContent.current.showIntroEditor(true)
    }
    if (this._references.estimateItemAdd.current) {
      this._references.estimateItemAdd.current.hide()
    }
  }

  async _onAddTermsAndCondition () {
    this.data.showTermsAndCondition = true

    if (!this.data.estimate.termsAndCondition) {
      this.data.estimate.termsAndCondition = await getTermsAndConditions(
        app.getTeamId(),
        'estimate'
      )

      this.setState({ dataDate: new Date() })

      // Update terms and conditions
      if (this.data.estimate.termsAndCondition) {
        const updateObj = {
          termsAndCondition: this.data.estimate.termsAndCondition
        }

        this._onUpdateEstimateInfo(updateObj)
      }
    }
  }

  _onAddDiscountPhase () {
    const hasDiscountPhase = (this.data.budget?.phases || []).find(phase => phase.type === PHASE_TYPES.DISCOUNT)

    if (hasDiscountPhase) {
      return this._references.estimateContent.current.onAddActivity('time-activity')
    }

    this._references.estimateContent.current.addPhase({ type: PHASE_TYPES.DISCOUNT })
  }

  _renderTermsAndCondition () {
    const { estimate, showTermsAndCondition } = this.data
    if (!showTermsAndCondition || !estimate) {
      return null
    }
    return (
      <TermsAndConditionText
        text={estimate.termsAndCondition}
        onChange={this.handleOnChangeTermsAndConditon}
        onBlur={this.handleOnBlurTermsAndConditon}
        onDelete={this.handleOnDeleteTermsAndCondition}
      />
    )
  }

  handleOnChangeTermsAndConditon = (value) => {
    this.data.estimate.termsAndCondition = value
    if (value === '') {
      this.data.termsCleared = true
    }
    this.setState({ dataDate: new Date() })
  };

  handleOnBlurTermsAndConditon = () => {
    const updateObj = {
      termsAndCondition: this.data.estimate.termsAndCondition
    }

    this._onUpdateEstimateInfo(updateObj)
  };

  handleOnDeleteTermsAndCondition = () => {
    this.data.termsCleared = true
    this._onUpdateEstimateInfo({ termsAndCondition: '' }, () => {
      this.data.estimate.termsAndCondition = ''
      this.data.showTermsAndCondition = false

      this.setState({ dataDate: new Date() })
    })
  };

  _onUpdateEstimateType (type) {
    const updateObj = { type: type }
    this._onUpdateEstimateInfo(updateObj, null)
  }

  _onCreateTaxRate (rateObj) {
    const address = this.data.estimate.contactAddress
    if (address && address.state) {
      this.data.taxRateVatOptions.push(rateObj)
      this.setState({ dataDate: new Date() })

      app
        .service('/api/taxrate/create')
        .create({
          state: address.state,
          rate: rateObj
        })
        .catch((err) => {
          app.debug('PageEstimateView: _onCreateTaxRate Error', err)
        })
    }
  }

  _onUpdateIntroText (introText) {
    const updateObj = { introText: introText || null }
    this._onUpdateEstimateInfo(updateObj, null)
  }

  _onUpdateEstimateInfo (updateObj, callback) {
    if (!this.data.estimate.id) {
      return
    }

    const saveObj = _.cloneDeep(updateObj)
    if (saveObj.budget) {
      saveObj.budget = BudgetUtil.getSaveObject(saveObj.budget, true).budget
    }

    if (Object.keys(saveObj).length > 0) {
      app
        .service('/api/estimate')
        .patch(this.data.estimate.id, saveObj)
        .then((_introRes) => {
          if (callback) {
            callback(null)
          }
        })
        .catch((introErr) => {
          app.debug('PageEstimateView: _onUpdateEstimateInfo err', introErr)
        })
    }
  }

  _onPhaseRemove (phaseId, removeData, callback) {
    if (this.data.budget?.phases) {
      this.data.budget.phases.splice(phaseId, 1)
    }

    app
      .service('/api/common/removephase')
      .create(removeData)
      .then((_res) => {
        callback(null)
      })
      .catch((removeErr) => {
        app.debug('PageProjectViewBudget: _onPhaseRemove err', removeErr)
      })
  }

  _onPhaseAdd (ev) {
    ev.preventDefault()
    if (this._references.estimateItemAdd.current) {
      this._references.estimateItemAdd.current.hide()
    }
    if (this._references.estimateContent.current) {
      this._references.estimateContent.current.addPhase()
    }
  }

  _onTimeActivityAdd (ev) {
    ev.preventDefault()
    if (this._references.estimateItemAdd.current) {
      this._references.estimateItemAdd.current.hide()
    }
    if (this._references.estimateContent.current) {
      this._references.estimateContent.current.onAddActivity('time-activity')
    }
  }

  _onTextAdd (ev) {
    ev.preventDefault()

    if (this._references.estimateItemAdd.current) {
      this._references.estimateItemAdd.current.hide()
    }
    if (this._references.estimateContent.current) {
      this._references.estimateContent.current.onAddActivity('text')
    }
  }

  _onFABEstimateViewAddClose () {
    this._hideCloseFABButton()
  }

  _onCopyProjectBudget (ev) {
    ev.preventDefault()

    const createObj = {
      estimateId: this.data.estimate.id,
      projectId: this.data.estimate.projectId
    }

    app
      .service('/api/estimate/copybudgetitem')
      .create(createObj)
      .then((_copyBudgetItemRes) => {
        if (this._references.estimateItemAdd.current) {
          this._references.estimateItemAdd.current.hide()
        }
        this._getData(true, false, (budgetErr) => {
          if (budgetErr) {
            app.debug('PageEstimateView: _onCopyProjectBudget err', budgetErr)
          } else {
            const newBudget = BudgetUtil.getRenderObject(
              this.data.budget,
              this.data.items
            )
            if (this._references.estimateContent.current) {
              this._references.estimateContent.current.refreshBudget(
                newBudget,
                this.data.estimate
              )
            }
          }
        })
      })
      .catch((copyBudgetItemResErr) => {
        if (copyBudgetItemResErr.message === 'Project closed') {
          this.showError(copyBudgetItemResErr.message)
        }
        app.debug(
          'PageEstimateView: _onCopyProjectBudget err',
          copyBudgetItemResErr
        )
      })
  }

  _reloadData () {
    this._getData(true, true)
  }

  _onSubmitAddressInvoice (updateObj) {
    const estimate = this.data.estimate
    const contactAddresses = []
    let bUpdateExistingCont = false

    if (estimate.contactAddress !== undefined) {
      estimate.contact.addresses.map((address) => {
        if (address.type === estimate.contactAddress.type) {
          bUpdateExistingCont = true
          address.street = updateObj.address.street
            ? updateObj.address.street
            : address.street
          address.postcode = updateObj.address.postcode
            ? updateObj.address.postcode
            : address.postcode
          address.city = updateObj.address.city
            ? updateObj.address.city
            : address.city
          address.state = updateObj.address.state
            ? updateObj.address.state
            : address.state
          address.country = updateObj.address.country
            ? updateObj.address.country
            : address.country
          address.type = address.type ? address.type : 'Estimate'
        }
        contactAddresses.push(address)
      })
    }

    const address = {
      street: updateObj.address.street,
      postcode: updateObj.address.postcode,
      city: updateObj.address.city,
      state: updateObj.address.state,
      country: updateObj.address.country,
      type: updateObj.address.type ? updateObj.address.type : 'Estimate',
      streetNumber: updateObj.address.streetNumber
    }

    const contObj = {
      company: updateObj.company,
      addresses:
        bUpdateExistingCont && contactAddresses && contactAddresses.length > 0
          ? contactAddresses
          : [address],
      vatNo: updateObj.vatNo
    }

    if (updateObj.contactPersons && updateObj.contactPersons.length > 0) {
      contObj.contactPersons = updateObj.contactPersons
    }

    async.series(
      [
        (done) => {
          this._updateContactAddresses(contObj, done)
        },
        (done) => {
          this._updateEstimateContact(updateObj, done)
        }
      ],
      (err, _res) => {
        if (err) {
          if (this._references.refDialogInvoiceAddress.current) {
            this._references.refDialogInvoiceAddress.current.showError()
          }
          app.debug('PageEstimateView: _onSubmitAddressInvoice err', err)
        } else {
          if (this.showApprove) {
            if (this._references.refDialogEstimateFinalize.current) {
              this._references.refDialogEstimateFinalize.current.hide()
            }
            this._getData(true, false, (_res) => {
              this._onFinalize()
            })
          }
          if (this._references.refDialogInvoiceAddress.current) {
            this._references.refDialogInvoiceAddress.current.hide()
          }
        }
      }
    )
  }

  /* Private functions */
  _updateContactAddresses (contactObj, callback) {
    app
      .service('/api/contact')
      .patch(this.data.estimate.contactId, contactObj)
      .then((_contRes) => {
        callback(null)
      })
      .catch((contUpdateErr) => {
        app.debug(
          'PageEstimateView: _updateContactAddresses err',
          contUpdateErr
        )
        callback(contUpdateErr)
      })
  }

  _updateEstimateContact (updateObj, callback) {
    const estimateObj = {
      contactAddress: updateObj.address
    }

    if (updateObj.selectedContactPerson) {
      estimateObj.contactPerson = updateObj.selectedContactPerson
    }

    app
      .service('/api/estimate')
      .patch(this.data.estimate.id, estimateObj)
      .then((_decRes) => {
        callback(null)
      })
      .catch((estUpdateErr) => {
        app.debug(
          'PageEstimateView: _updateEstimateContactAddresses err',
          estUpdateErr
        )
        callback(estUpdateErr)
      })
  }

  _renderAddItem () {
    if (this.data.estimate?.status !== 'Draft' && this.data.estimate?.status !== 'Open') {
      return null
    }

    return (
      <EstimateAddItem
        ref={this._references.estimateItemAdd}
        onClose={() => this._onFABEstimateViewAddClose()}
        onIntroAdd={e => this._onIntroAdd(e)}
        onCopyBudget={e => this._onCopyProjectBudget(e)}
        onAddTermsAndCondition={() => this._onAddTermsAndCondition()}
        onAddDiscountPhase={() => this._onAddDiscountPhase()}
      />
    )
  }

  _getVatAmount (amount, vat) {
    if (vat && parseFloat(vat) > 0) {
      const vatAmount = parseFloat(amount) * (parseFloat(vat) / 100)
      return currency.round(vatAmount)
    }

    return 0
  }

  /* Realtime Events */
  _initEvents () {
    this._eventHandlers.estimatePatched = this._eventReload.bind(
      this,
      'Estimate',
      'Patched'
    )

    const estimateService = app.service('/api/estimate')
    estimateService.on('patched', this._eventHandlers.estimatePatched)
  }

  _eventReload (objectName, eventName, eventData) {
    if (this._canRealTimeReload() && eventfilters.teamFilter(eventData)) {
      app.debug(
        `-- Event - PageEstimateView - ${objectName} - ${eventName} --`
      )
      this._reloadData()
    }
  }

  _releaseEvents () {
    const estimateService = app.service('/api/estimate')
    estimateService.off('patched', this._eventHandlers.estimatePatched)

    this._eventHandlers.estimatePatched = null
  }

  /* Header Functions - START */
  renderHeader () {
    const { estimate } = this.data
    const { loading: { isCreatingInvoice, isReopening } } = this.state
    if (!estimate) {
      return null
    }

    const useProjectNumber = app.projectSetting.useProjectNo
    const projectNumber = estimate.project
      ? estimate.project.projectNumber
      : ''

    const statInfos = [
      useProjectNumber &&
        projectNumber && {
          title: 'estimate.list.labelProjectNumber',
          value: `${projectNumber}`,
          onClick: this._onHeaderOpenProject.bind(this, estimate.projectId)
        },
      {
        title: 'estimate.list.labelProject',
        value: estimate.project ? estimate.project.title : '',
        isPrice: false,
        onClick: this._onHeaderOpenProject.bind(this, estimate.projectId)
      },
      {
        title: 'estimate.list.labelEstimate',
        value: (estimate && estimate.estimateNumber) || '',
        isPrice: false
      }
    ].filter(Boolean)

    if (estimate.status !== 'Draft' && estimate.status !== 'Open') {
      let invoicedAmount = 0
      if (estimate.items && estimate.items.length > 0) {
        invoicedAmount = _.sumBy(estimate.items, (item) =>
          item.status === 'Final' ? parseFloat(item.total || 0) : 0
        )
      }

      statInfos.push(
        {
          title: 'estimate.list.labelAmountInvoiced',
          value: invoicedAmount,
          isPrice: true
        },
        {
          title: 'estimate.list.labelReferencePo',
          value: estimate.referenceNumber || '',
          isPrice: false
        }
      )
    }

    /*
      Actions should be show based on estimate status
      1. Draft: edit, mail, download pdf, mark as open
      2. Open: edit, mail, download pdf, approve, declined
      3. Approved: mail, download pdf, download attachment, reopen, create invoice
      4. Declined: mail, download pdf, reopen (#699)
    */

    const rightActions = []
    const { pdfDownloadUrl } = this
    const actions = [
      {
        ident: 'mail',
        icon: 'mail',
        tooltip: 'estimate.view.tipMail',
        tooltipPosition: 'bottom',
        onClick: this._onSendMail.bind(this)
      },
      {
        ident: 'download',
        icon: 'download-solid',
        tooltip: 'estimate.view.tipDownload',
        tooltipPosition: 'bottom',
        href: estimate.id ? pdfDownloadUrl : '#',
        target: '_blank'
      }
    ]

    if (estimate.status === 'Draft' || estimate.status === 'Open') {
      actions.unshift({
        ident: 'edit',
        icon: 'edit',
        tooltip: 'estimate.view.tipEditDetails',
        tooltipPosition: 'bottom',
        onClick: this._onEdit.bind(this)
      })

      if (estimate.status === 'Draft') {
        rightActions.push({
          ident: 'like',
          icon: 'done',
          tooltip: 'estimate.view.tipMarkOpen',
          tooltipPosition: 'bottomright',
          size: 'big',
          type: 'success',
          onClick: this._onClickMarkAsOpen
        })
      } else {
        rightActions.push(
          {
            ident: 'like',
            icon: 'thumb',
            tooltip: 'estimate.view.tipApprove',
            tooltipPosition: 'bottomright',
            size: 'big',
            type: 'success',
            onClick: this._onApprove
          },
          {
            ident: 'unlike',
            icon: 'thumb',
            tooltip: 'estimate.view.tipDecline',
            tooltipPosition: 'bottomright',
            className: 'reverse',
            hasConfirm: true,
            confirmTitle: 'estimate.view.msgDecline',
            size: 'big',
            type: 'error',
            onClick: this._onChangeStatus.bind(this, 'Declined')
          }
        )
      }
    } else {
      if (estimate.status === 'Approved') {
        if (estimate.file && estimate.file.fileName) {
          actions.push({
            ident: 'download',
            icon: 'download-solid',
            tooltip: 'estimate.view.tipDownloadAttachment',
            tooltipPosition: 'bottom',
            href: encodeURI(
              `/estimate/previewfile/${estimate.teamId}/${estimate.file.fileName}`
            ),
            target: '_blank'
            /* onClick: this._onOpenAttachment.bind(this) */
          })
        }

        rightActions.push({
          ident: 'invoiceestimate',
          className: 'filterbutton lightbg',
          icon: 'introduction',
          tooltip: 'estimate.view.invoiceText',
          tooltipPosition: 'bottomright',
          size: 'big',
          type: isCreatingInvoice ? 'disabled' : 'success',
          onClick: this._onCreateInvoice.bind(this),
          isLoading: isCreatingInvoice
        })
      }

      rightActions.push({
        ident: 'reopen',
        className: 'filterbutton lightbg',
        icon: 'reset',
        tooltip: 'estimate.view.tipReopen',
        tooltipPosition: 'bottomright',
        size: 'big',
        type: isReopening ? 'disabled' : 'success',
        onClick: this._onChangeStatus.bind(this, 'Open'),
        isLoading: isReopening
      })
    }

    // Show estimate status in first
    actions.unshift({
      ident: 'status',
      type: 'button',
      title: estimate.status ? Util.getTranslatedStatus(estimate.status) : '',
      className: `headerstatus estimate_${estimate.status.toLowerCase()}`
    })

    return (
      <PageHeader
        icon={<EstimatesIcon width={25} />}
        title={estimate.contact ? estimate.contact.company : ''}
        isTitleMultilingual={false}
        isMultilingual={false}
        statInfos={statInfos}
        alignStatInfos='bottom'
        alignActions='left'
        actions={actions}
        rightActions={rightActions}
      />
    )
  }

  _onHeaderOpenProject (projectId) {
    app.changePage('projectview-budget', projectId)
  }
  /* Header Functions - END */
}

export default PageEstimateView
